import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputHasAtLeatOneDigitErrorMessage = (
  <Trans>
    Ce champ doit contenir un chiffre
  </Trans>
);
